import { useEffect, useState } from "react";
import {
  useGetBankTransactionList,
  useGetRebatesAccount,
} from "../../../../hooks/api/queries";
import { getUrlQuerysection } from "../../../../helpers";
import { useSearchParams } from "react-router-dom";
const useAllTransaction = () => {
  const [fundsMovement, setFundsMovement] = useState(null);
  const queries = getUrlQuerysection();
  const [search, setSearch] = useSearchParams();
  const [selectedRebates, setSelectedRebates] = useState();
  const [isDownloadStatement, setIsDownloadStatement] = useState(false);

  const {
    isLoading: isLoadingRebatesAccount,
    data: rebatesAccount,
    refetch: handleFetchRebatesAccount,
  } = useGetRebatesAccount();

  const {
    isLoading: isLoadingTransactions,
    data: Transactions,
    refetch: handleFetchTransactions,
  } = useGetBankTransactionList({ queries });

  const [startDate] = useState(search.get("start_date"));
  const [endDate] = useState(search.get("end_date"));

  const gotoPage = (pageNumber) => {
    search.set("page", pageNumber);
    setSearch(search, { replace: true });
  };

  const setDateFilter = (data) => {
    search.set("start_date", data.startDate);
    search.set("end_date", data.endDate);
    setSearch(search, { replace: true });
  };

  const searchByLedgerAccount = (ledger_account_id) => {
    search.set("ledger_account_id", ledger_account_id);
    setSearch(search, { replace: true });
  };

  useEffect(() => {
    if (
      !search.get("ledger_account_id") ||
      search.get("ledger_account_id") === undefined
    ) {
      handleFetchRebatesAccount();
      if (rebatesAccount?.data?.length > 0) {
        const rebatesId = rebatesAccount?.data?.[0]?.id;
        if (rebatesId) {
          search.set("ledger_account_id", rebatesId);
          setSearch(search, { replace: true });
          searchByLedgerAccount(rebatesId);
        }
      }
    } else {
      // handleFetchTransactions();
    }
  }, [rebatesAccount, search, setSearch]);

  return {
    metaDetails: Transactions?.meta,
    isLoadingTransactions,
    Transactions: Transactions?.data || [],
    handleFetchTransactions,
    fundsMovement,
    setFundsMovement,
    startDate,
    gotoPage,
    endDate,
    setDateFilter,
    selectedRebates,
    setSelectedRebates,
    isDownloadStatement,
    setIsDownloadStatement,
    isLoadingRebatesAccount,
    rebatesAccount: rebatesAccount?.data || [],
    handleFetchRebatesAccount,
    searchByLedgerAccount,
  };
};

export default useAllTransaction;
